<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <div
    class="pt-0"
    style="position: relative"
  >
    <div
      class=" py-2 px-4"
      style="position: sticky;top: 0;background:rgb(250, 251, 252);z-index: 6;"
    >
      <div class="d-flex align-center">
        <back-button
          @close-event="close"
        >
          mdi-close
        </back-button>
        <template v-if="!loading">
          <page-sub-header>
            {{ $t('dishesDetail') }} / {{ name }}
          </page-sub-header>
        </template>
        <template v-else>
          <page-header class="py-4 pb-6">
            {{ $t('loading') }}
          </page-header>
        </template>
        <v-spacer />

        <v-btn
          class="mr-2 primary lighten-4"
          elevation="0"
          @click="removeImage"
        >
          {{ $t('removeImage') }}
        </v-btn>
        <v-btn
          :disabled="!valid"
          :loading="loading"
          class="mr-2 amber lighten-4 black--text"
          elevation="0"
          @click="save"
        >
          {{ $t('save_change') }}
        </v-btn>
      </div>
      <v-tabs
        v-model="infoTab"
        background-color="transparent"
        class="mt-2"
        color="black"
        grow
      >
        <v-tab>{{ $t('ProductBasicInformation') }}</v-tab>
        <v-tab>{{ $t('ProductDetails') }}</v-tab>
        <v-tab v-if="adminMode !== 'supermarket'">
          {{ $t('ProductAttribute') }}
        </v-tab>
        <v-tab v-if="adminMode !== 'supermarket'">
          {{ $t('ProductVisibility') }}
        </v-tab>
      </v-tabs>
    </div>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div
        v-if="!loading"
        class="mt-4 px-4"
      >
        <v-tabs-items v-model="infoTab">
          <v-tab-item>
            <div class="mt-4">
              <template v-for="(field,index) in groupedFields">
                <div
                  :key="field.value+index+'group'"
                >
                  <div class="d-flex flex-wrap align-center">
                    <div>
                      <div class="text-h4 font-weight-medium">
                        {{ $t('' + field.groupName) }}
                      </div>
                      <div class="text-caption">
                        {{ $t('other_lang_could_not_be_filled_if_not_fill_just_one_lang_can_be_used') }}
                      </div>
                    </div>
                    <v-spacer />
                    <div class="d-flex">
                      <div>
                        <v-tabs
                          v-model="langTab"
                          color="#232123"
                          height="36px"
                          show-arrows
                          style="background: transparent!important;"
                        >
                          <v-tab
                            v-for="(child,i) in field.children"
                            :key="field.value+'c'+editedItem[field.value][i][field.childLabelKey]+'tab'"
                          >
                            {{ $t(editedItem[field.value][i][field.childLabelKey].toLowerCase()) }}
                            <span
                              v-if="i===0"
                              class="red--text"
                            > * </span>
                          </v-tab>
                        </v-tabs>
                      </div>
                    </div>
                  </div>
                  <v-tabs-items
                    v-model="langTab"
                    class="mt-4"
                  >
                    <v-tab-item
                      v-for="(child,i) in field.children"
                      :key="i+'dishId'"
                    >
                      <template v-for="(c,t) in child">
                        <div :key="field.id+'t'+t+'c'+i">
                          <form-field
                            v-if="editedItem[field.value]"
                            :current-state="1"
                            :edited-item="editedItem[field.value][i]"
                            :field="c"
                            no-details
                          />
                        </div>
                      </template>
                    </v-tab-item>
                  </v-tabs-items>
                </div>
              </template>
              <div
                style="display: grid;grid-gap: 16px;grid-template-columns: repeat(1,minmax(0,1fr))"
              >
                <template v-for="(field,index) in requiredFields">
                  <div
                    v-if="isRefreshCategory"
                    :key="'f1'+index+field.text"
                  >
                    <form-field
                      :current-state="1"
                      :edited-item="editedItem"
                      :field="field"
                      no-details
                      @click="addNew(-1)"
                    />
                  </div>
                </template>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div
              v-if="imageField.length>0"
            >
              <form-field
                :current-state="1"
                :edited-item="editedItem"
                :field="imageField[0]"
                no-details
              />
            </div>

            <template v-for="(field,index) in notRequiredFields">
              <div
                v-if="isRefreshAllergen"
                :key="'f2'+index"
                class="my-4"
              >
                <form-field
                  :current-state="1"
                  :edited-item="editedItem"
                  :field="field"
                  no-details
                  @click="addNewAllergen(-1)"
                />
              </div>
            </template>
          </v-tab-item>
          <div v-if="adminMode !== 'supermarket'">
            <v-tab-item>
              <attribute-edit-fragment
                :dishes-id="id"
                @update-mod-list="e=>editedItem.attributeGroupId=e"
              />
            </v-tab-item>
          </div>
          <div v-if="adminMode !== 'supermarket'">
            <v-tab-item>
              <div class="my-4">
                <div class="text-caption pb-1">
                  {{ $t('dishesShowThisMenu') }}
                </div>
                <v-select
                  v-model="selectedShowThisMenu"
                  :items="consumeTypeList"
                  :menu-props="{offsetY:true, outlined:true,
                                contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                  :placeholder="$t('chooseMenu')"
                  item-text="name"
                  item-value="id"
                  multiple
                  outlined
                  return-object
                />
              </div>
              <div class="my-4">
                <div class="text-caption pb-1">
                  {{ $t('dishesFreeThisMenu') }}
                </div>
                <v-select
                  v-model="selectedFreeMenu"
                  :items="consumeTypeList"
                  :menu-props="{offsetY:true, outlined:true, contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                  :placeholder="$t('dishesFreeThisMenu')"
                  item-text="name"
                  item-value="id"
                  multiple
                  outlined
                  return-object
                />
              </div>
            </v-tab-item>
          </div>
        </v-tabs-items>
      </div>
      <div
        v-else
        class="d-flex align-center justify-center"
        style="height: 400px;"
      >
        <v-progress-circular indeterminate />
      </div>
    </v-form>

    <ik-entity-form
      v-model="showCategoryDialog"
      :edited-index="activeCategoryIndex"
      :model="categoryModel"
      @need-refresh="loadCategory"
    />
    <ik-entity-form
      v-model="showAllergenDialog"
      :edited-index="activeAllergenIndex"
      :model="AllergenModel"
      @need-refresh="loadAllergen"
    />
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import Dish, { removeDishImage } from '@/model/dataLayer/api/dish/Dish'

import IKUtils from 'innerken-js-utils'
import Category from '@/model/dataLayer/api/dish/Category'
import Allergen from '@/model/dataLayer/api/dish/Allergen'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import DishesConsumeType from '@/model/dataLayer/api/buffet/DishesConsumeType'
import { keyBy } from 'lodash'
import { copyToAll, showSuccessMessage } from '@/model/utils/utils'
import AttributeEditFragment from '@/views/AadenPages/dishes/dish/detail/fragments/AttributeEditFragment'
import i18n from '@/i18n'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'
import hillo from 'hillo'
import FormField from '@/plugins/EntityFrameWork/FormField.vue'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import store from '@/model/global/store'

export default {
  name: 'DishesDetail',
  components: {
    AttributeEditFragment,
    IkEntityForm,
    FormField,
    PageHeader,
    BackButton,
    PageSubHeader
  },
  props: {
    id: {
      default: -1
    },
    outSideList: {}
  },
  data () {
    return {
      selectedFreeMenu: [],
      selectedShowThisMenu: [],
      consumeTypeList: [],
      AllergenModel: Allergen,
      activeAllergenIndex: null,
      showAllergenDialog: null,
      isRefreshAllergen: true,
      categoryModel: Category,
      showCategoryDialog: null,
      activeCategoryIndex: null,
      isRefreshCategory: true,
      loading: false,
      langTab: null,
      model: Dish,
      valid: true,
      formField: [],
      currentList: [],
      IKDataEntity,
      defaultItem: null,
      calculateDefaultItem: null,
      editedItem: null,
      keyStore: {},

      infoTab: 0

    }
  },
  computed: {
    adminMode () {
      return store.state.adminMode
    },
    requiredFields: function () {
      return this.notGroupedFields.filter(f => this.fieldIsRequired(f))
    },
    notRequiredFields: function () {
      return this.notGroupedFields.filter(f => !this.fieldIsRequired(f))
    },
    groupedFields: function () {
      return this.notImageField.filter(f => f.dataType === IKDataEntity.Types.Group)
    },
    notGroupedFields: function () {
      return this.notImageField.filter(f => f.dataType !== IKDataEntity.Types.Group)
    },
    imageField: function () {
      return this.formField.filter(f => f.dataType === IKDataEntity.Types.Image)
    },
    uniqueField: function () {
      return this.formField.filter(f => f.unique)
    },
    notImageField: function () {
      return this.formField.filter(f => f.dataType !==
          IKDataEntity.Types.Image && !f.onlyAction)
    },
    name () {
      return (this?.editedItem?.name ?? this.editedItem?.dishName ?? i18n.t('loading'))
    }
  },
  async mounted () {
    await this.initialize()
  },
  methods: {
    async initialize () {
      await this.wait(async () => {
        console.time('start');
        [, this.formField, this.calculateDefaultItem] = await IKDataEntity.parseField(this.model)
        Object.freeze(this.calculateDefaultItem)
        await this.refreshList()

        this.editedItem = IKUtils.deepCopy(this.currentList.find(i => parseInt(i.id) === parseInt(this.id)))
        console.timeEnd('start')
        setTimeout(async () => {
          await this.initialForm()
          this.consumeTypeList = (await ConsumeType.getList(true))
          await this.refreshVisibility()
        }, 10)
      })
    },
    async refreshVisibility () {
      const showingInfo = keyBy((await hillo.get('Dishes.php?op=showDishShowAndFreeInAllConsumeType', {
        dishId: this.id
      })).content, 'id')
      for (const c of this.consumeTypeList) {
        const showing = showingInfo[c.id.toString()].showing === '1'
        const free = showingInfo[c.id.toString()].free === '1'
        if (showing) {
          this.selectedShowThisMenu.push(c)
        }
        if (free) {
          this.selectedFreeMenu.push(c)
        }
      }
    },
    addNewAllergen (index) {
      this.showAllergenDialog = true
      this.activeAllergenIndex = index
    },
    async loadAllergen (item) {
      this.isRefreshAllergen = false
      this.editedItem.AllergenId.push(parseInt(item.content.id))
      await Allergen.getList(true)
      this.isRefreshAllergen = true
    },
    async loadCategory (item) {
      this.isRefreshCategory = false
      this.editedItem.categoryId = parseInt(item.content.id)
      await Category.getList(true)
      this.isRefreshCategory = true
    },
    async addNew (index) {
      this.showCategoryDialog = true
      this.activeCategoryIndex = index
    },

    fieldIsRequired (field) {
      return field.required && field.requiredEdit
    },

    async refreshList () {
      this.currentList = this.outSideList
    },
    async initialForm () {
      if (this.uniqueField.length > 0) {
        this.keyStore = {}
        this.keyStore = await this.uniqueField.reduce(async (obj, i) => {
          const trackingList = i.uniqueTrackingList ? await i.uniqueTrackingList() : this.currentList
          obj[i.value] = trackingList.map(it => it[i.value]).filter(it => it !== this.editedItem[i.value])
          return obj
        }, {})
        this.uniqueField.forEach(it => {
          it.rule = []
          if (this.keyStore[it.value]) {
            const uniqueCheck = val => (this.keyStore[it.value] && !this.keyStore[it.value].includes(val)) || i18n.t(
              it.text) + ': ' + val + ' ' + i18n.t('AlreadyInUse')
            it.rule.push(uniqueCheck)
          }
        })
      }
    },

    async wait (action) {
      this.loading = true
      try {
        await action()
      } catch (e) {

      }
      this.loading = false
    },

    async removeImage () {
      await removeDishImage(this.editedItem.dishId)
      showSuccessMessage('图片删除成功！')
      this.close(true)
    },

    async save () {
      for (const f of this.groupedFields) {
        copyToAll(f, this.editedItem[f.value])
      }
      if (!this.$refs.form.validate()) {
        return
      }
      await this.wait(async () => {
        await IKUtils.safeCallFunction(this.model, this.model.edit, this.editedItem)
        setTimeout(async () => {
          const showDict = keyBy(this.selectedShowThisMenu, 'id')
          const freeDict = keyBy(this.selectedFreeMenu, 'id')
          for (const d of this.consumeTypeList) {
            (await DishesConsumeType.edit({
              consumeTypeId: (d.id).toString(),
              dishId: this.id,
              showing: showDict[d.id],
              isFree: freeDict[d.id]
            }))
          }
        }, 50)

        showSuccessMessage(i18n.t('edit_success'))
        this.close(true)
      })
    },

    close (shouldRefresh) {
      this.$emit('close', shouldRefresh)
    }
  }
}
</script>

<style>
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none;
}
</style>
